module.exports = (__webpack_require__(9))(15);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/antd/es/icon/index.js from dll-reference antd_library
// module id = 343
// module chunks = 42